import { List } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import LoadMoreBtn from '../LoadMoreBtn/LoadMoreBtn'

const LoadMoreList = ({ listContent, initialSize, interval, hideDisabled, renderItem = i => <p>{i}</p> }) => {
    const [list, setList] = useState([...listContent].slice(0, initialSize))
    const [size, setSize] = useState(initialSize)
    const [disabledMore, setDisabledMore] = useState(listContent.count <= initialSize)
    const [disabledLess, setDisabledLess] = useState(true)

    const sleep = milliseconds => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }
    const onLoad = async (addSub) => {
        const newSize = size + interval * (addSub ? 1 : -1)
        const updatedList = [...listContent].slice(0, newSize)
        await sleep(1000)
        setSize(newSize)
        setList(updatedList)
        setDisabledMore(newSize >= listContent.length)
        setDisabledLess(newSize <= initialSize)
    }

    const onLoadMore = async () => await onLoad(true)
    const onLoadLess = async () => await onLoad(false)

    return <>
        {
            (list || [])?.length > 0 &&
            <List
                dataSource={list}
                itemLayout="vertical"
                locale={{ emptyText: ' ' }}
                renderItem={renderItem}
                size="large"
            />
        }
        <LoadMoreBtn
            hideDisabled={hideDisabled}
            disabledLess={disabledLess}
            disabledMore={disabledMore}
            onClickMore={onLoadMore}
            onClickLess={onLoadLess} />
    </>
}

LoadMoreList.propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClickMore: PropTypes.func,
    onClickLess: PropTypes.func
}

export default LoadMoreList
